module.exports = {
	"JobDetail.descriptionHeading": "Description",
	"JobDetail.requirementsHeading": "Requirements",
	"JobDetail.benefitsHeading": "Benefits",
	"JobDetail.applyLink": "Apply for this role",
	"Jobs.title": "Jobs",
	"JobList.title": "Jobs",
	"JobList.intro1": "Depop HQ is located in the heart of Shoreditch, London, with offices in Milan and NYC.",
	"JobList.intro2": "Don't see a job listing that piques your interest, but desperately want to be part of our fabulous team? Email us at work@depop.com. We love working with people who are as passionate about Depop as we are.",
	"Collections.heading": "Featured Collections",
	"PasswordResetComplete.matchError": "Passwords don't match.",
	"PasswordResetComplete.serverError": "There was a problem changing the password.",
	"PasswordResetComplete.defaultLinkTitle": "Password Reset",
	"PasswordResetComplete.invalidLinkTitle": "Password Reset Link Not Valid",
	"PasswordResetComplete.successLinkTitle": "Password Reset Successful",
	"PasswordResetComplete.passwordPlaceholder": "New password",
	"PasswordResetComplete.passwordAgainPlaceholder": "New password, again",
	"RequestPasswordReset.invalidMessage": "Sorry, it doesn't look like this a valid password reset link. Perhaps you've already reset your password with this link?",
	"RequestPasswordReset.invalidCta": "Request a new password reset link",
	"RequestPasswordReset.successMessage": "Your password has been changed! Try logging in.",
	"RequestPasswordReset.defaultTitle": "Enter a new password",
	"PasswordResetRequest.error": "Could not reset password for that user",
	"PasswordResetRequest.title": "Reset Password",
	"PasswordResetRequest.titleSent": "Email On The Way!",
	"PasswordResetRequest.cta": "Send",
	"PasswordResetRequest.formFieldPlaceholder": "Email or username",
	"PasswordResetRequest.formTitleSent": "Email On The Way!",
	"RequestPasswordReset.sentMessage": "Check your inbox, there should be something there from us.",
	"RequestPasswordReset.formTitle": "Forgot your password?",
	"RequestPasswordReset.description": "Enter your email or username to receive a link to change your password.",
	"Homepage.greeting": "Hello, we're open. Hello we're Depop. We inspire people to find things they love. We believe in passion, creativity and connection. We believe that shopping should be fun and easy. Create your own shop, discover and share your favorite things. Welcome to our community.",
	"Homepage.exploreHeading": "Explore items",
	"ProductSearch.noResults": "No results found. Search for something different.",
	"Search.title": "Search Results",
	"Search.queryPlaceholder": "Search for items",
	"LikeButton.Like": "Like",
	"LikeButton.Unlike": "Unlike",
	"ShopManageBar.saveLabel": "Save",
	"ShopManageBar.cancelRearrange": "Cancel",
	"BuyButton.Buy": "Buy",
	"ProductCreateForm.productCreated": "Product published",
	"ProductCreateForm.photosLabel": "Photos",
	"ProductCreateForm.photosHelp": "Drag and drop up to 4 photos in JPEG or PNG format",
	"ProductCreateForm.descriptionLabel": "Description",
	"ProductCreateForm.usernamePlaceholder": "Include as many details as possible: brand, condition, colour, style, etc",
	"ProductCreateForm.categoryLabel": "Category",
	"ProductCreateForm.categoryPlaceholder": "Select a category",
	"ProductCreateForm.sizeLabel": "Size",
	"ProductCreateForm.sizePlaceholder": "Select a size",
	"ProductCreateForm.quantityLabel": "Quantity",
	"ProductCreateForm.domesticShippingLabel": "National Shipping",
	"ProductCreateForm.internationalShippingLabel": "International Shipping",
	"ProductCreateForm.priceLabel": "Price",
	"ProductCreateForm.sizeRequired": "Select a size",
	"ProductCreateForm.quantityRequired": "Please enter quantities",
	"ProductCreateForm.addAnotherSize": "Add another size",
	"ProductCreateForm.addInternationalShipping": "Add international shipping",
	"ProductCreateForm.buttonAnotherLabel": "Publish and add another",
	"ProductCreateForm.buttonLabel": "Publish",
	"ProductCreateNotConnected.title": "Oops... looks like your PayPal isn't connected. Please connect your PayPal account in app to start listing items for sale.",
	"ProductCreateNotConnected.message": "Oops... looks like your PayPal is not connected. Please connect your PayPal account in the app to start listing items for sale",
	"ProductCreateNotLoggedIn.title": "Oops... you need to login to sell",
	"ProductCreateNotLoggedIn.linkText": "login",
	"ProductCreateNotLoggedIn.message": "Oops... you need to {link} to sell",
	"FeedbackList.title": "Feedback for {name}",
	"FeedbackList.close": "Close",
	"FeedbackList.toggleSold": "Sold",
	"FeedbackList.togglePurchased": "Purchased",
	"FeedbackList.emptyState": "{name} hasn't received any feedback",
	"FeedbackModalContent.toggleSold": "Sold",
	"FeedbackModalContent.togglePurchased": "Purchased",
	"FeedbackModalContent.title": "Feedback for {name}",
	"FeedbackModalContent.close": "Close",
	"FeedbackModalContent.noSellerFeedback": "No feedback as seller",
	"FeedbackModalContent.noBuyerFeedback": "No feedback as buyer",
	"FollowButton.unfollowLabelLower": "following",
	"FollowButton.followLabelLower": "follow",
	"app.unfollowLabelUpper": "Following",
	"app.followLabelUpper": "Follow",
	"FollowersList.heading": "People who follow {name}",
	"FollowingList.heading": "People who {name} follow",
	"ProductComments.showMoreComments": "{count, plural, =0 {0 comments} one {1 comment} other {Show all {count} comments...}}",
	"ProductComments.collapseComments": "Show fewer comments",
	"RelationsModalContent.toggleFollowers": "Followers",
	"RelationsModalContent.toggleFollowing": "Following",
	"RelationsModalContent.close": "Close",
	"RelationsModalContent.noFollowers": "No followers",
	"RelationsModalContent.noFollowing": "No following",
	"ShopToggles.Selling": "Selling",
	"ShopToggles.Likes": "Likes",
	"ProductDetail.similarItems": "More things you might like",
	"SocialCounters.followers": "{count, plural, =0 {0 Followers} one {1 Follower} other {{count} Followers}}",
	"SocialCounters.following": "{count, plural, =0 {0 Following} one {1 Following} other {{count} Following}}",
	"ProductCreate.headline": "Sell",
	"ProductDetail.title": "{username} is selling a product on Depop",
	"ProductDetail.numLikes": "{count, plural, =0 {0 likes} one {1 like} other {{count} likes}}",
	"ShopDetail.title": "{name}'s Shop",
	"ShopDetail.noProductsForSale": "{username} isn't selling anything yet. Check back later.",
	"ShopManageBar.moveSoldItemsDownLabel": "Move sold items down",
	"ShopDetail.rearrangeButton": "Rearrange",
	"ShopFollowers.title": "{username}'s Followers",
	"ShopFollowers.noFollowers": "{username} has no followers.",
	"ShopFollowing.title": "{username}'s Following",
	"ShopFollowing.noFollowing": "{username} doesn't follow anybody.",
	"ShopLikes.title": "{username}'s Likes",
	"ShopDetail.noLikedProducts": "{username} hasn't liked any products. Check back later.",
	"SuggestedProducts.title": "Suggested Products",
	"SuggestedUsers.title": "Suggested Users",
	"AppBanner.openApp": "Open in app",
	"CropModal.cancel": "Cancel",
	"CropModal.submit": "Save",
	"app.aboutLabel": "About",
	"app.jobsLabel": "Jobs",
	"app.blogLabel": "Blog",
	"app.supportLabel": "Support",
	"app.profileLabel": "Profile",
	"app.downloadLabel": "Download App",
	"Login.close": "Close",
	"Login.or": "or",
	"Login.facebookFailed": "We couldn’t log you in using your Facebook account, log in with your password instead?",
	"Login.getTheApp": "Don’t have an account? Get the app to sign up",
	"FacebookLogin.buttonLabel": "Login with Facebook",
	"LoginForm.usernamePlaceholder": "Username or email address",
	"LoginForm.passwordPlaceholder": "Password",
	"Login.forgotPassword": "Forgot?",
	"LoginForm.buttonLabel": "Login",
	"Login.loginError": "Something went wrong",
	"MultiplePictureInput.tooManyImages": "Too many images selected!",
	"MultiplePictureInput.filesTooSmall": "1 or more of your files is smaller than 1280x1280",
	"MultiplePictureInput.invalidFormat": "1 or more of your files isn't a JPEG or PNG",
	"MultiplePictureInput.dropLabel": "Drop images here to upload",
	"ProductListItem.cannotBeDisplayed": "This product cannot be displayed.",
	"RelayWrapper.error": "Something went wrong, try again?",
	"GlobalSearch.queryPlaceholder": "Search for items",
	"app.closeGlobalSearch": "Close",
	"TextMeTheApp.close": "Close",
	"TextMeTheApp.heading": "Depop is the simplest and most fun way to buy, sell and discover millions of items and sellers. Get the app now:",
	"TextMeTheApp.message": "Or enter your mobile number to receive a link to download the app:",
	"TextMeTheApp.formCancel": "Cancel",
	"formValidation.required": "This field is required",
	"formValidation.maxLength": "Max length {value} characters",
	"formValidation.minValue": "This field has a minimum value of {value}",
	"formValidation.maxValue": "This field has a maximum value of {value}",
	"formValidation.minPrice": "This field has a minimum of {value}",
	"formValidation.maxPrice": "This field has a maximum of {value}",
	"formValidation.minArrayLength": "This field has a maximum length of {value}",
	"formValidation.maxArrayLength": "This field has a maximum length of {value}",
	"Application.defaultDescription": "Depop. Sell with a snap, buy with a tap.",
	"app.searchLabel": "Search",
	"app.menuLabel": "Menu",
	"app.loginLabel": "Login",
	"app.logoutLabel": "Logout",
	"NotFound.title": "Page Not Found",
	"NotFound.messageAppLinkText": "use the app instead",
	"NotFound.message": "Sorry, that page doesn't exist. Try again or {link}",
	"NotFound.smallMessage": "404 page not found"
};


//////////////////
// WEBPACK FOOTER
// ../src/locale/en.json
// module id = 944
// module chunks = 17